import React from "react";
import Button from "../ui/Button/Button.jsx";
import { ArrowRight } from "lucide-react";
import { useHistory } from "react-router-dom"; // Import useHistory from react-router-dom

const JoinUsSection = () => {
  const history = useHistory(); // Get the history object from react-router-dom

  // Navigate to the form in the about page
  const handleExploreOpportunities = () => {
    history.push("/about"); // Navigate first
    setTimeout(() => {
      // Wait for page transition
      const element = document.getElementById("finalSection");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 50);
  };

  return (
    <section className="py-20 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-red-400 ">
            Join Us in Shaping the Future of AI
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            We're always looking for passionate researchers and collaborators to
            join our team.
          </p>
          <div className="mt-10">
            <Button
              variant="primary"
              size="md"
              rounded="3xl"
              rightIcon={<ArrowRight className="h-4 w-4" />}
              className="bg-gray-900 hover:bg-red-600"
              onClick={handleExploreOpportunities}
            >
              Explore Opportunities
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinUsSection;
